import React, {useEffect } from 'react';
import '../style/cardStyle.css'

const RepeatNumberOverlay = ({ repeat, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 500);

    return () => clearTimeout(timer); 
  }, [onClose]);

  return (
    <div className="repeat-overlay zoom-in-out">
      {repeat + 1}
    </div>
  );
};

export default RepeatNumberOverlay;